import React from "react";
import "./privacy-policy.scss";
import Breadcrumb from "../../components/common/breadcrumb";
import Header from "../HeaderNew/component";

const PrivacyPolicy = (props) => {
  return (
    <>
      <Header />
      <Breadcrumb />
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12">
            <div className="privacy-policy-kl">
              <div className="privacy-policy-container-kl">
                <div className="privacy-policy-title-kl">Return Policy</div>
                <p className="mb-4 text-black">At Kiko Live, the return and refund policies
                  may differ based on the seller and the product category.</p>
                <div className="mb-4">
                  <div className="privacy-policy-sub-title-kl">
                    Return Policy for ONDC Network Sellers
                  </div>
                  <p>
                    For products sold by sellers on the ONDC Network, some items are marked as
                    non-returnable. This will be clearly noted on the product page.
                  </p>
                </div>
                <div className="mb-4">
                  <div className="privacy-policy-sub-title-kl">
                    Cancellable Orders
                  </div>
                  <ul>
                    <li>
                      Customers can cancel eligible orders at any time before shipment.
                    </li>
                    <li>
                      Once an order has been shipped, cancellation is no longer possible.
                    </li>
                  </ul>
                </div>
                <div className="mb-4">
                  <div className="privacy-policy-sub-title-kl">
                    Returnable Items
                  </div>
                  <ul>
                    <li>
                      For returnable items, customers can initiate returns through the My Orders section.
                    </li>
                    <li>
                      Products must be returned in their original condition for the return to be accepted.
                    </li>
                    <li>
                      The seller will arrange for the pickup of the returned item, and a refund will be issued once the product has been received and inspected by the seller.
                    </li>
                  </ul>
                </div>
                <div className="mb-4">
                  <div className="privacy-policy-sub-title-kl">
                    Seller-Specific Return Policies
                  </div>
                  <p>
                    The return policy outlines the actions to be taken if customers require post-delivery support. This can include exchanges, replacements, or refunds, depending on the situation. A transparent return policy ensures customer satisfaction and builds trust, which is beneficial to sellers in the long term.
                  </p>
                </div>
                <div className="mb-4">
                  <div className="privacy-policy-sub-title-kl">
                    Proof of Dispatch (POD):
                  </div>
                  <p>
                    When post-delivery support is requested, sellers must provide proof of dispatch, including images or videos of the product both in its package and unpacked. These visuals help verify the condition of the items delivered.
                  </p>
                </div>
                <div className="mb-4">
                  <div className="privacy-policy-sub-title-kl">
                    Return Scenarios and Resolution Process
                  </div>
                </div>
                <div className="mb-4">
                  <div className="privacy-policy-sub-title-kl">
                    Defective, Damaged, or Incorrect Items
                  </div>
                  <ul>
                    <li>
                      If a product is defective, damaged, or not as described, the seller must provide proof of dispatch (photos/videos).
                    </li>
                    <li>
                      If the seller is at fault, the order will be disputed, and the seller must either replace the item or confirm a refund and arrange for pickup.
                    </li>
                    <li>
                      The seller will bear the logistics costs for both the return and replacement shipments.
                    </li>
                    <li>
                      Estimated Time for Resolution (ETR): 7 days.
                    </li>
                  </ul>
                </div>
                <div className="mb-4">
                  <div className="privacy-policy-sub-title-kl">
                    Additional Return Terms
                  </div>
                  <ul>
                    <li>
                      Sellers must confirm replacement or refund within 2 days if:
                    </li>
                  </ul>
                  <ul className="mt-3 pl-5">
                    <li>The product was damaged before shipment and was not harmed during transit.</li>
                    <li>Packaging guidelines were not followed, causing damage during delivery.</li>
                    <li>The item does not match the description on the product page.</li>
                    <li>The product is expired, unsuitable for its intended use, or missing essential parts.</li>
                  </ul>
                </div>
                <div className="mb-4">
                  <div className="privacy-policy-sub-title-kl">
                    Contact Us
                  </div>
                  <p>For any inquiries related to returns, please reach out to our customer support team via email at help@kiko.live.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
